import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-integration-checkbox',
  templateUrl: './integration-checkbox.component.html',
  styleUrls: ['./integration-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class IntegrationCheckboxComponent {
  @Input() payload: any;
  @Output() close = new EventEmitter<any>();
}
